import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { HomeLoading } from "../home/HomeLoading";

export const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return <HomeLoading />;
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    return children;
};
